import type { OptionDefinitions } from "building-types/options/optionDefinitions";
import type { DocOptionSet } from "building-types/options/optionSet";

/**
 * Returns the DocOptionSet that holds option definitions for `optionSetId`.
 *
 * Archetype IDs return that top-level row.
 * Instance IDs return the archetype when the instance row exists in the definitions.
 */
export function getOptionSetArchetypeOrSelf(
  definitions: OptionDefinitions,
  optionSetId: string,
): DocOptionSet | undefined {
  const { optionSets, instanceOptionSets } = definitions;

  const direct = optionSets[optionSetId];
  if (direct) {
    return direct;
  }

  const instance = instanceOptionSets[optionSetId];
  if (instance) {
    return optionSets[instance.archetypeId];
  }

  return undefined;
}
